export const CUSTOM_TRANSPORT_ICONS = [
  { id: 'motorcycle', label: 'Motorcycle', file: 'icon-moto.svg' },
  { id: 'car', label: 'Car', file: 'icon-car.svg' },
  { id: 'walk', label: 'Walk', file: 'icon-ped.svg' },
  { id: 'truck', label: 'Truck', file: 'icon-truck.svg' },
  { id: 'bicycle', label: 'Bicycle', file: 'icon-bike.svg' },
  { id: 'bus', label: 'Bus', file: 'icon-bus.svg' },
  { id: 'van', label: 'Van', file: 'icon-van.svg' },
  { id: 'scooter', label: 'Scooter', file: 'icon-scooter.svg' },
  { id: 'taxi', label: 'Taxi', file: 'icon-taxi.svg' },
  { id: 'rv', label: 'RV', file: 'icon-rv.svg' },
];

export const DEFAULT_CUSTOM_TRANSPORT_ICON = 'motorcycle';

export function normalizeCustomTransportIcon(raw, fallbackKey = '') {
  const id = String(raw || '').trim().toLowerCase();
  if (CUSTOM_TRANSPORT_ICONS.some((item) => item.id === id)) return id;
  const key = String(fallbackKey || '').trim().toLowerCase();
  if (key === 'motorcycle' || key.includes('moto')) return 'motorcycle';
  if (key.includes('bike') || key.includes('bicycle')) return 'bicycle';
  if (key.includes('bus')) return 'bus';
  if (key.includes('scooter')) return 'scooter';
  if (key.includes('taxi')) return 'taxi';
  if (key.includes('truck') || key.includes('commercial')) return 'truck';
  if (key.includes('ped') || key.includes('walk')) return 'walk';
  if (key.includes('van')) return 'van';
  if (key.includes('rv') || key.includes('camper')) return 'rv';
  return DEFAULT_CUSTOM_TRANSPORT_ICON;
}

export function customTransportIconSrc(iconOrMode, fallbackKey = '') {
  const id = normalizeCustomTransportIcon(iconOrMode, fallbackKey);
  const match = CUSTOM_TRANSPORT_ICONS.find((item) => item.id === id);
  return `/redesign/${match?.file || 'icon-moto.svg'}`;
}
